import axios, { AxiosInstance } from 'axios'
import { useAuthService } from '@invivodf/front-seller-auth'

const NO_TIMEOUT = 0

interface Options {
  timeout?: number
  accept?: string
}

export function createAxiosClientAnonymous(
  baseUrl: string,
  { timeout = NO_TIMEOUT, accept = 'application/json' }: Options = {},
) {
  return axios.create({
    baseURL: `${baseUrl}`,
    timeout,
    headers: {
      Accept: accept,
    },
  })
}

export function createHttpClientWithBearer(baseUrl: string, options: Options = {}): AxiosInstance {
  const client = createAxiosClientAnonymous(baseUrl, options)
  client.interceptors.request.use(async (config) => {
    const authService = useAuthService()
    const accessToken = await authService.getAccessToken()
    if (accessToken !== null) {
      // eslint-disable-next-line no-param-reassign
      config.headers.Authorization = `Bearer ${accessToken}`
    }
    return config
  })
  return client
}
